export default `
  mutation requestAccountDeletion {
    requestAccountDeletion {
      requestedAt
    }
  }
`
